import styled from "styled-components";

export const SectionShell = styled.section`
	display: flex;
	flex-direction: column;
	gap: 18px;
	width: 100%;
`;

export const DashboardCard = styled.section`
	display: flex;
	flex-direction: column;
	gap: ${({ gap = "16px" }) => gap};
	width: 100%;
	padding: ${({ padding = "20px 22px" }) => padding};
	border-radius: 14px;
	border: 1px solid rgba(120, 139, 160, 0.16);
	background-color: var(--light-1);
	box-shadow: 0 12px 26px -30px rgba(26, 39, 68, 0.28);

	@media (max-width: 900px) {
		padding: 18px;
	}
`;

export const HeaderGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(260px, 1fr) minmax(260px, auto) minmax(280px, auto);
	gap: 12px;
	align-items: center;

	@media (max-width: 1260px) {
		grid-template-columns: minmax(0, 1fr) minmax(280px, 1fr);
	}

	@media (max-width: 900px) {
		grid-template-columns: 1fr;
	}
`;

export const HeaderTitleBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`;

export const Eyebrow = styled.span`
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const HeaderTitle = styled.h3`
	margin: 0;
	font-size: 21px;
	line-height: 1.08;
	font-weight: 700;
	color: var(--black);
`;

export const HeaderSubtitle = styled.p`
	margin: 0;
	font-size: 13px;
	line-height: 1.45;
	color: var(--light-gray-5);
	max-width: 680px;
`;

export const MetaInlineList = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
`;

export const MetaInlineItem = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 5px 9px;
	border-radius: 999px;
	background-color: rgba(232, 239, 248, 0.82);
	font-size: 11px;
	line-height: 1.3;
	color: var(--dark-4);
`;

export const HeaderStatusBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	min-width: 0;
	padding: 8px 10px;
	border-radius: 8px;
	background:
		linear-gradient(135deg, rgba(244, 248, 252, 0.95), rgba(250, 252, 255, 0.98));
	border: 1px solid rgba(120, 139, 160, 0.14);
`;

export const StatusCluster = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
`;

export const StatusBlockLabel = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const HeaderMetaText = styled.span`
	font-size: 12px;
	line-height: 1.4;
	color: var(--light-gray-5);
`;

export const HeaderActions = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
	min-width: 0;

	@media (max-width: 1260px) {
		grid-column: 1 / -1;
		flex-direction: row;
		justify-content: flex-end;
		flex-wrap: wrap;
	}

	@media (max-width: 900px) {
		justify-content: stretch;

		& > * {
			flex: 1 1 100%;
		}
	}
`;

export const ActionGroup = styled.div`
	display: flex;
	align-items: center;
	min-width: 0;
`;

export const ActionHint = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.03em;
	text-transform: uppercase;
	color: ${({ $tone = "default" }) =>
		$tone === "warning" ? "#8a5a00" : "var(--light-gray-3)"};
`;

export const MetricsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(5, minmax(0, 1fr));
	gap: 6px;

	@media (max-width: 1260px) {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	@media (max-width: 900px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	@media (max-width: 640px) {
		grid-template-columns: 1fr;
	}
`;

export const MetricCard = styled.article`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 3px;
	min-width: 0;
	padding: 10px 12px 11px;
	border-radius: 8px;
	border: 1px solid ${({ $tone = "neutral" }) => {
		switch ($tone) {
			case "healthy":
				return "rgba(16, 185, 129, 0.18)";
			case "attention":
				return "rgba(245, 158, 11, 0.2)";
			case "critical":
				return "rgba(239, 68, 68, 0.18)";
			case "info":
				return "rgba(59, 130, 246, 0.14)";
			default:
				return "rgba(120, 139, 160, 0.14)";
		}
	}};
	background-color: ${({ $tone = "neutral" }) => {
		switch ($tone) {
			case "healthy":
				return "rgba(236, 252, 245, 0.88)";
			case "attention":
				return "rgba(255, 249, 235, 0.92)";
			case "critical":
				return "rgba(254, 242, 242, 0.92)";
			case "info":
				return "rgba(239, 246, 255, 0.86)";
			default:
				return "rgba(244, 248, 252, 0.9)";
		}
	}};
	overflow: hidden;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 3px;
		background-color: ${({ $tone = "neutral" }) => {
			switch ($tone) {
				case "healthy":
					return "rgba(16, 185, 129, 0.75)";
				case "attention":
					return "rgba(245, 158, 11, 0.78)";
				case "critical":
					return "rgba(239, 68, 68, 0.78)";
				case "info":
					return "rgba(59, 130, 246, 0.6)";
				default:
					return "rgba(120, 139, 160, 0.4)";
			}
		}};
	}
`;

export const MetricLabel = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const MetricValue = styled.strong`
	font-size: 23px;
	line-height: 1;
	font-weight: 700;
	color: var(--black);
`;

export const MetricCaption = styled.span`
	font-size: 11px;
	line-height: 1.35;
	color: var(--light-gray-5);
`;

export const SupportGrid = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.35fr) minmax(320px, 1fr);
	gap: 14px;

	@media (max-width: 1180px) {
		grid-template-columns: 1fr;
	}
`;

export const TopSecondaryStack = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const CompactPanel = styled.section`
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	align-items: center;
	gap: 10px;
	padding: 9px 10px;
	border-radius: 8px;
	border: 1px solid rgba(120, 139, 160, 0.14);
	background-color: rgba(248, 251, 255, 0.7);

	@media (max-width: 760px) {
		grid-template-columns: 1fr;
		align-items: flex-start;
	}
`;

export const AttentionRail = styled.section`
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 2px 0 0;
`;

export const AttentionHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
`;

export const AttentionLabel = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const SecondaryRail = styled.section`
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 2px 0 0;
`;

export const SecondaryRailHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
`;

export const SecondaryRailLabel = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const PanelEyebrow = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const PanelHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
`;

export const PanelTitleGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const PanelTitle = styled.h4`
	margin: 0;
	font-size: 13px;
	font-weight: 700;
	color: var(--black);
`;

export const PanelSubtitle = styled.p`
	margin: 0;
	font-size: 11px;
	line-height: 1.4;
	color: var(--light-gray-5);
`;

export const StatusPill = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	padding: 4px 8px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 600;
	line-height: 1.2;
	background-color: ${({ $variant }) => {
		switch ($variant) {
			case "success":
				return "rgba(16, 185, 129, 0.14)";
			case "danger":
				return "rgba(239, 68, 68, 0.14)";
			case "warning":
				return "rgba(245, 158, 11, 0.16)";
			case "info":
				return "rgba(59, 130, 246, 0.12)";
			default:
				return "rgba(148, 163, 184, 0.18)";
		}
	}};
	color: ${({ $variant }) => {
		switch ($variant) {
			case "success":
				return "#0f766e";
			case "danger":
				return "#b91c1c";
			case "warning":
				return "#a16207";
			case "info":
				return "#1d4ed8";
			default:
				return "#475569";
		}
	}};
`;

export const InsightList = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
`;

export const InsightRow = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	flex: 1 1 260px;
	padding: 6px 9px 6px 11px;
	border-radius: 8px;
	border: 1px solid ${({ $tone = "neutral" }) => {
		switch ($tone) {
			case "healthy":
				return "rgba(16, 185, 129, 0.16)";
			case "warning":
				return "rgba(245, 158, 11, 0.18)";
			case "critical":
				return "rgba(239, 68, 68, 0.18)";
			default:
				return "rgba(120, 139, 160, 0.12)";
		}
	}};
	background-color: ${({ $tone = "neutral" }) => {
		switch ($tone) {
			case "healthy":
				return "rgba(240, 253, 247, 0.58)";
			case "warning":
				return "rgba(255, 250, 236, 0.62)";
			case "critical":
				return "rgba(254, 242, 242, 0.64)";
			default:
				return "rgba(248, 251, 255, 0.56)";
		}
	}};

	&::before {
		content: "";
		position: absolute;
		left: 0;
		top: 8px;
		bottom: 8px;
		width: 3px;
		border-radius: 999px;
		background-color: ${({ $tone = "neutral" }) => {
			switch ($tone) {
				case "healthy":
					return "rgba(16, 185, 129, 0.75)";
				case "warning":
					return "rgba(245, 158, 11, 0.78)";
				case "critical":
					return "rgba(239, 68, 68, 0.78)";
				default:
					return "rgba(120, 139, 160, 0.42)";
			}
		}};
	}
`;

export const InsightContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
`;

export const InsightTitle = styled.span`
	font-size: 12px;
	font-weight: 600;
	line-height: 1.35;
	color: var(--dark-4);
`;

export const InsightDescription = styled.span`
	font-size: 10px;
	line-height: 1.35;
	color: var(--light-gray-5);
`;

export const ConfigList = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
`;

export const ConfigSummaryPanel = styled.section`
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 0;
`;

export const ConfigSummaryLine = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1fr) auto;
	align-items: center;
	gap: 10px;
	padding: 0;

	@media (max-width: 760px) {
		grid-template-columns: 1fr;
		align-items: flex-start;
	}
`;

export const EditorDialogBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
	min-width: 0;
	min-height: 0;
	max-height: calc(100vh - 210px);
	overflow-y: auto;
	padding-right: 4px;

	@media (max-width: 900px) {
		max-height: calc(100vh - 180px);
	}

	@media (max-width: 560px) {
		max-height: calc(100vh - 164px);
		padding-right: 2px;
	}
`;

export const EditorDialogFooterNote = styled.p`
	margin: 0;
	font-size: 11px;
	line-height: 1.4;
	color: var(--light-gray-5);
`;

export const EditorDialogMessage = styled.div`
	padding: 10px 12px;
	border-radius: 10px;
	border: 1px solid rgba(239, 68, 68, 0.16);
	background-color: rgba(254, 242, 242, 0.8);
	font-size: 12px;
	line-height: 1.4;
	color: #b91c1c;
`;

export const ConfigMetaTokens = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	min-width: 0;
`;

export const ConfigMetaToken = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;
	border-radius: 999px;
	font-size: 11px;
	font-weight: ${({ $variant = "default" }) =>
		$variant === "success" ? 700 : 600};
	line-height: 1.2;
	border: 1px solid
		${({ $variant = "default" }) =>
			$variant === "success"
				? "rgba(16, 185, 129, 0.18)"
				: "rgba(120, 139, 160, 0.14)"};
	background-color: ${({ $variant = "default" }) =>
		$variant === "success"
			? "rgba(236, 252, 245, 0.92)"
			: "rgba(244, 248, 252, 0.88)"};
	color: ${({ $variant = "default" }) =>
		$variant === "success" ? "#0f766e" : "var(--dark-4)"};
`;

export const ConfigSummaryAction = styled.button`
	border: 1px solid rgba(120, 139, 160, 0.18);
	border-radius: 999px;
	background-color: transparent;
	color: var(--purple-2);
	padding: 4px 9px;
	font-size: 11px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.18s ease, border-color 0.18s ease;

	&:hover {
		background-color: rgba(90, 0, 217, 0.04);
		border-color: rgba(85, 64, 218, 0.26);
	}
`;

export const ConfigDetails = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-top: 8px;
	border-top: 1px solid rgba(120, 139, 160, 0.1);
`;

export const ConfigMetaCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 100px;
	padding: 8px 10px;
	border-radius: 8px;
	background-color: rgba(244, 248, 252, 0.9);
	border: 1px solid rgba(120, 139, 160, 0.12);
`;

export const ConfigMetaLabel = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const ConfigMetaValue = styled.span`
	font-size: 12px;
	line-height: 1.35;
	font-weight: 600;
	color: var(--dark-4);
	word-break: break-word;
`;

export const SignatureSummaryGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 6px;

	@media (max-width: 1180px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	@media (max-width: 760px) {
		grid-template-columns: 1fr;
	}
`;

export const SignatureSummaryCard = styled.div`
	display: grid;
	grid-template-columns: 48px minmax(0, 1fr);
	align-items: start;
	gap: 8px 10px;
	padding: 8px 10px 9px;
	border-radius: 8px;
	border: 1px solid rgba(120, 139, 160, 0.14);
	background:
		linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.92));
`;

export const SignatureSummaryContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
`;

export const SignatureSummaryTop = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
`;

export const SignatureIndex = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	border-radius: 999px;
	border: 1px solid rgba(85, 64, 218, 0.32);
	color: var(--purple-2);
	font-size: 12px;
	font-weight: 700;
`;

export const SignaturePosition = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 5px 8px;
	border-radius: 999px;
	background-color: rgba(85, 64, 218, 0.08);
	color: var(--purple-2);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.04em;
	align-self: start;
`;

export const SignatureType = styled.span`
	font-size: 12px;
	font-weight: 600;
	line-height: 1.35;
	color: var(--dark-4);
	text-transform: none;
`;

export const SignatureName = styled.span`
	font-size: 11px;
	line-height: 1.35;
	color: var(--light-gray-5);
	word-break: break-word;
`;

export const SectionHeaderRow = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 14px;
	flex-wrap: wrap;

	@media (max-width: 1024px) {
		align-items: stretch;
	}
`;

export const SectionTitleGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	@media (max-width: 1024px) {
		flex: 1 1 100%;
	}
`;

export const SectionTitle = styled.h4`
	margin: 0;
	font-size: 17px;
	font-weight: 700;
	color: var(--black);
`;

export const SectionDescription = styled.p`
	margin: 0;
	font-size: 12px;
	line-height: 1.45;
	color: var(--light-gray-5);
`;

export const ToolbarCluster = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
	min-width: 0;

	@media (max-width: 1024px) {
		width: 100%;
		justify-content: flex-start;
	}
`;

export const SearchCluster = styled.div`
	display: flex;
	align-items: stretch;
	gap: 8px;
	flex-wrap: wrap;
	min-width: 0;
	justify-content: flex-end;

	@media (max-width: 1024px) {
		width: 100%;
		justify-content: flex-start;
	}

	@media (max-width: 720px) {
		width: 100%;
	}
`;

export const SearchInput = styled.input`
	width: 300px;
	flex: 1 1 280px;
	max-width: 100%;
	min-width: 0;
	border: 1px solid rgba(120, 139, 160, 0.22);
	border-radius: 10px;
	padding: 9px 12px;
	font-size: 13px;
	color: var(--dark-4);
	background-color: var(--light-1);

	&:focus {
		outline: 0;
		border-color: rgba(85, 64, 218, 0.45);
		box-shadow: 0 0 0 3px rgba(85, 64, 218, 0.08);
	}

	@media (max-width: 1024px) {
		width: auto;
	}
`;

export const FilterBar = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`;

export const FilterButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	border: 1px solid
		${({ $active }) =>
			$active ? "rgba(85, 64, 218, 0.38)" : "rgba(120, 139, 160, 0.18)"};
	background-color: ${({ $active }) =>
		$active ? "rgba(90, 0, 217, 0.08)" : "var(--light-1)"};
	color: ${({ $active }) => ($active ? "var(--purple-2)" : "var(--dark-4)")};
	border-radius: 999px;
	padding: 7px 11px;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
`;

export const FilterCount = styled.span`
	font-size: 11px;
	font-weight: 700;
	color: inherit;
	opacity: 0.72;
`;

export const ResultsSummary = styled.span`
	font-size: 12px;
	line-height: 1.4;
	color: var(--light-gray-5);
`;

export const PaginationRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px 14px 0;
	flex-wrap: wrap;
	border-top: 1px solid rgba(120, 139, 160, 0.12);

	@media (max-width: 760px) {
		padding: 12px 12px 0;
		flex-direction: column;
		align-items: stretch;
	}
`;

export const PaginationInfo = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1 1 auto;
	min-width: 0;
`;

export const PaginationPageChip = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 5px 12px;
	border-radius: 999px;
	border: 1px solid rgba(85, 64, 218, 0.16);
	background-color: rgba(90, 0, 217, 0.05);
	font-size: 11px;
	font-weight: 700;
	line-height: 1.2;
	color: var(--purple-6);
	text-align: center;
`;

export const PaginationActions = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	@media (max-width: 760px) {
		width: 100%;
		justify-content: flex-end;
	}
`;

export const PaginationButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 34px;
	height: 34px;
	padding: 0;
	border-radius: 999px;
	border: 1px solid rgba(120, 139, 160, 0.18);
	background-color: var(--light-1);
	color: var(--dark-4);
	cursor: pointer;
	transition: background-color 0.18s ease, border-color 0.18s ease,
		color 0.18s ease, opacity 0.18s ease;

	&:hover:not(:disabled) {
		background-color: rgba(244, 248, 252, 0.96);
		border-color: rgba(85, 64, 218, 0.2);
		color: var(--purple-6);
	}

	&:disabled {
		opacity: 0.52;
		cursor: not-allowed;
	}
`;

export const PaginationArrow = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transform: rotate(${({ $direction = "left" }) =>
		$direction === "left" ? "90deg" : "270deg"});
`;

export const SectionActionRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;

	@media (max-width: 1024px) {
		width: 100%;
		justify-content: flex-start;
	}
`;

export const AccordionTrigger = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 4px 0;
	border: 0;
	background: transparent;
	color: var(--purple-6);
	font-size: 12px;
	font-weight: 600;
	line-height: 1.2;
	cursor: pointer;
	text-align: left;

	& svg {
		transition: transform 0.2s ease;
		transform: rotate(${({ $expanded = false }) => ($expanded ? "180deg" : "0deg")});
	}

	&:disabled {
		opacity: 0.55;
		cursor: not-allowed;
	}
`;

export const LegendRail = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 14px 18px;
	align-items: center;

	@media (max-width: 1024px) {
		gap: 10px 16px;
	}

	@media (max-width: 760px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const LegendGroup = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
	min-width: 0;

	@media (max-width: 760px) {
		width: 100%;
	}
`;

export const LegendLabel = styled.span`
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: var(--light-gray-3);
`;

export const LegendItems = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
`;

export const SignalLegendItem = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	font-size: 11px;
	line-height: 1.2;
	color: var(--light-gray-5);
	white-space: nowrap;
`;

export const SignalStack = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px;
	justify-content: flex-start;
`;

export const SignalBadge = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: ${({ $size = "default" }) => ($size === "legend" ? "26px" : "28px")};
	height: ${({ $size = "default" }) => ($size === "legend" ? "26px" : "28px")};
	border-radius: 999px;
	border: 1px solid ${({ $variant = "neutral" }) => {
		switch ($variant) {
			case "success":
				return "rgba(16, 185, 129, 0.18)";
			case "danger":
				return "rgba(239, 68, 68, 0.18)";
			case "warning":
				return "rgba(245, 158, 11, 0.2)";
			default:
				return "rgba(120, 139, 160, 0.14)";
		}
	}};
	background-color: ${({ $variant = "neutral" }) => {
		switch ($variant) {
			case "success":
				return "rgba(236, 252, 245, 0.92)";
			case "danger":
				return "rgba(254, 242, 242, 0.92)";
			case "warning":
				return "rgba(255, 249, 235, 0.92)";
			default:
				return "rgba(244, 248, 252, 0.92)";
		}
	}};

	& svg {
		width: 16px;
		height: 16px;
	}

	& svg path,
	& svg circle {
		transition: fill 0.18s ease;
	}

	& svg {
		flex-shrink: 0;
	}
`;

export const TableShell = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid rgba(120, 139, 160, 0.16);
	border-radius: 14px;
	overflow: hidden;
	background-color: var(--light-1);
`;

export const TableHeader = styled.div`
	display: grid;
	grid-template-columns: minmax(240px, 2.05fr) minmax(150px, 0.92fr) minmax(250px, 1.75fr) minmax(180px, 1fr) minmax(112px, 0.68fr);
	gap: 12px;
	padding: 12px 16px;
	background-color: rgba(242, 247, 252, 0.98);
	border-bottom: 1px solid rgba(120, 139, 160, 0.16);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: var(--light-gray-3);
	position: sticky;
	top: 0;
	z-index: 2;
	align-items: center;

	& > span {
		justify-self: start;
		text-align: left;
	}

	@media (max-width: 1180px) {
		display: none;
	}
`;

export const TableRow = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: minmax(240px, 2.05fr) minmax(150px, 0.92fr) minmax(250px, 1.75fr) minmax(180px, 1fr) minmax(112px, 0.68fr);
	gap: 12px;
	padding: 12px 16px;
	border-top: 1px solid rgba(120, 139, 160, 0.12);
	align-items: center;
	background-color: ${({ $tone = "default" }) => {
		switch ($tone) {
			case "critical":
				return "rgba(254, 242, 242, 0.7)";
			case "warning":
				return "rgba(255, 251, 235, 0.72)";
			case "healthy":
				return "rgba(240, 253, 247, 0.66)";
			default:
				return "var(--light-1)";
		}
	}};
	transition: background-color 0.18s ease;

	&:first-of-type {
		border-top: 0;
	}

	&::before {
		content: "";
		position: absolute;
		left: 0;
		top: 8px;
		bottom: 8px;
		width: 3px;
		border-radius: 999px;
		background-color: ${({ $tone = "default" }) => {
			switch ($tone) {
				case "critical":
					return "rgba(239, 68, 68, 0.72)";
				case "warning":
					return "rgba(245, 158, 11, 0.78)";
				case "healthy":
					return "rgba(16, 185, 129, 0.74)";
				default:
					return "transparent";
			}
		}};
	}

	&:hover {
		background-color: ${({ $tone = "default" }) => {
			switch ($tone) {
				case "critical":
					return "rgba(254, 242, 242, 0.9)";
				case "warning":
					return "rgba(255, 251, 235, 0.92)";
				case "healthy":
					return "rgba(240, 253, 247, 0.88)";
				default:
					return "rgba(248, 251, 255, 0.9)";
			}
		}};
	}

	@media (max-width: 1180px) {
		grid-template-columns: minmax(0, 1fr) auto auto;
		grid-template-areas:
			"participant signals actions"
			"detail detail date";
		align-items: start;
		gap: 10px 12px;
	}

	@media (max-width: 760px) {
		grid-template-columns: 1fr;
		grid-template-areas:
			"participant"
			"signals"
			"detail"
			"date"
			"actions";
	}
`;

export const TableCell = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
	align-items: flex-start;

	@media (max-width: 1180px) {
		&:nth-child(1) {
			grid-area: participant;
		}

		&:nth-child(2) {
			grid-area: signals;
			justify-self: end;
		}

		&:nth-child(3) {
			grid-area: detail;
		}

		&:nth-child(4) {
			grid-area: date;
			justify-self: end;
		}

		&:nth-child(5) {
			grid-area: actions;
			justify-self: end;
		}
	}

	@media (max-width: 760px) {
		&:nth-child(2),
		&:nth-child(4),
		&:nth-child(5) {
			justify-self: start;
		}
	}
`;

export const BatchTableHeader = styled.div`
	display: grid;
	grid-template-columns: minmax(190px, 1.2fr) minmax(130px, 0.95fr) minmax(90px, 0.5fr) minmax(110px, 0.75fr) minmax(220px, 1.45fr) minmax(170px, 1fr);
	gap: 12px;
	padding: 12px 16px;
	background-color: rgba(242, 247, 252, 0.98);
	border-bottom: 1px solid rgba(120, 139, 160, 0.16);
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: var(--light-gray-3);
	position: sticky;
	top: 0;
	z-index: 2;
	align-items: center;

	& > span {
		justify-self: start;
		text-align: left;
	}

	@media (max-width: 1180px) {
		display: none;
	}
`;

export const BatchTableCell = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
	align-items: flex-start;

	@media (max-width: 1180px) {
		&:nth-child(1) {
			grid-area: identity;
		}

		&:nth-child(2) {
			grid-area: status;
			justify-self: end;
		}

		&:nth-child(3) {
			grid-area: revision;
		}

		&:nth-child(4) {
			grid-area: processed;
		}

		&:nth-child(5) {
			grid-area: result;
		}

		&:nth-child(6) {
			grid-area: date;
			justify-self: end;
		}
	}

	@media (max-width: 760px) {
		&:nth-child(2),
		&:nth-child(6) {
			justify-self: start;
		}
	}
`;

export const BatchMetaLine = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	padding: 10px 16px 8px;

	@media (max-width: 760px) {
		padding: 10px 12px 8px;
	}
`;

export const BatchMetaPillGroup = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
`;

export const BatchMetaPill = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 4px 8px;
	border-radius: 999px;
	font-size: 11px;
	line-height: 1.2;
	font-weight: 600;
	border: 1px solid rgba(120, 139, 160, 0.14);
	background-color: rgba(244, 248, 252, 0.88);
	color: var(--dark-4);
`;

export const CellLabel = styled.span`
	display: none;
	font-size: 10px;
	font-weight: 700;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: var(--light-gray-3);

	@media (max-width: 1180px) {
		display: inline-flex;
	}
`;

export const PrimaryValue = styled.span`
	font-size: 13px;
	font-weight: 600;
	line-height: 1.35;
	color: var(--black);
	word-break: break-word;
`;

export const SecondaryValue = styled.span`
	font-size: 11px;
	line-height: 1.35;
	color: var(--light-gray-5);
	word-break: break-word;
`;

export const StudentIdentity = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const ActionsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	justify-content: flex-start;

	@media (max-width: 1180px) {
		justify-content: flex-start;
	}

	@media (max-width: 760px) {
		gap: 10px;
	}
`;

export const ActionItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	min-width: 48px;
`;

export const ActionItemLabel = styled.span`
	display: none;
	font-size: 10px;
	line-height: 1.2;
	color: var(--light-gray-5);
	text-align: center;

	@media (max-width: 760px) {
		display: inline-flex;
	}
`;

export const EmptyState = styled.div`
	padding: 24px 16px;
	font-size: 13px;
	line-height: 1.5;
	color: var(--light-gray-5);
	text-align: center;
`;

export const BatchRow = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: minmax(190px, 1.2fr) minmax(130px, 0.95fr) minmax(90px, 0.5fr) minmax(110px, 0.75fr) minmax(220px, 1.45fr) minmax(170px, 1fr);
	gap: 12px;
	padding: 12px 16px;
	border-top: 1px solid rgba(120, 139, 160, 0.12);
	align-items: center;
	background-color: ${({ $tone = "default" }) =>
		$tone === "critical"
			? "rgba(254, 242, 242, 0.68)"
			: "var(--light-1)"};
	transition: background-color 0.18s ease;

	&:first-of-type {
		border-top: 0;
	}

	&::before {
		content: "";
		position: absolute;
		left: 0;
		top: 8px;
		bottom: 8px;
		width: 3px;
		border-radius: 999px;
		background-color: ${({ $tone = "default" }) =>
			$tone === "critical" ? "rgba(239, 68, 68, 0.72)" : "transparent"};
	}

	&:hover {
		background-color: ${({ $tone = "default" }) =>
			$tone === "critical"
				? "rgba(254, 242, 242, 0.9)"
				: "rgba(248, 251, 255, 0.9)"};
	}

	@media (max-width: 1180px) {
		grid-template-columns: minmax(0, 1fr) auto auto;
		grid-template-areas:
			"identity status date"
			"result result result"
			"revision processed processed";
		align-items: start;
		gap: 10px 12px;
	}

	@media (max-width: 760px) {
		grid-template-columns: 1fr;
		grid-template-areas:
			"identity"
			"status"
			"result"
			"revision"
			"processed"
			"date";
	}
`;

export const BatchIdentity = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3px;
`;

export const BatchType = styled.span`
	font-size: 13px;
	font-weight: 700;
	line-height: 1.35;
	color: var(--black);
	word-break: break-word;
`;

export const BatchId = styled.span`
	font-size: 11px;
	line-height: 1.35;
	color: var(--light-gray-5);
`;

export const ResultStack = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
`;

export const ResultPill = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 7px;
	border-radius: 999px;
	background-color: rgba(242, 247, 252, 0.96);
	font-size: 10px;
	font-weight: 600;
	line-height: 1.2;
	color: var(--dark-4);
`;
